import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "react-router-dom";
import { FRONTEND_ENDPOINTS } from "Theconstants";
import { moverDcha, moverIzq } from "utils/sliderCarousel";
const carouselItems = [
  {
    id: null, // or some identifier for static items
    image: "img/carousel/HotSale.jpeg",
  },
  {
    id: "63324686a409c4bc3379ee44",
    image: "img/carousel/CKdefy.jpeg",
  },
  {
    id: "6332360ea409c4bc3379ed63",
    image: "img/carousel/CHbadboy.jpeg",
  },
  {
    id: "632e60ca3b206ec3f3e1fd87",
    image: "img/carousel/myWayL.jpeg",
  },
  {
    id: "63be172834f922413327d88d",
    image: "img/carousel/alienL.jpeg",
  },
  {
    id: "66514266e613a5e90d97ef38",
    image: "img/carousel/GaultierDivine.jpeg",
  },
  {
    id: "68b2510b62c0a980cf144fa4",
    image: "img/carousel/arab.jpeg",
  },
  {
    id: "694a015ad6fbaf3c54c81f44",
    image: "img/carousel/idole.jpeg",
  },
];

const ContainerCarousel = styled.section`
  position: relative;
  height: 50vh;
  overflow: hidden;
  @media (max-width: 770px) {
    height: 35vh;
  }
`;
const SlideShow = styled.div`
  display: flex;
  //no borrar sino se sobreestira
  height: 100%;
`;
const CarouselItem = styled(Link)`
  position: relative;
  min-width: 100%;
  display: flex;
`;
export const Img = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
const ImgCont = styled(Link)<{ disappear?: boolean }>`
  height: 100%;
  width: 100%;
  background-color: black;

  @media (max-width: 1000px) {
    display: ${(props) => props.disappear && "none"};
  }
`;

export const Control = styled.div<{ dcha?: boolean }>`
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  position: absolute;
  right: ${(props) => (props.dcha ? "0" : undefined)};
  left: ${(props) => (props.dcha ? undefined : "0")};
  top: 0;
  bottom: 0;
  margin: auto calc(var(--fontMed) - 0.3rem);
  height: var(--fontLarge);
  width: var(--fontLarge);
  cursor: pointer;
  font-size: var(--fontMed);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Carousel = () => {
  const slideShow = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const idInterval = setInterval(() => {
      moverIzq(slideShow);
    }, 5000);
    return () => {
      idInterval && clearInterval(idInterval);
    };
  }, []);
  return (
    <>
      <ContainerCarousel>
        <SlideShow ref={slideShow}>
          {/*  */}
          {carouselItems.map((item) =>
            !item.id ? (
              <CarouselItem key={item.image} as="div">
                <Img src={item.image} />
              </CarouselItem>
            ) : (
              <CarouselItem
                key={item.id}
                to={FRONTEND_ENDPOINTS.dynamicSingleProduct(item.id)}
              >
                <Img src={item.image} />
              </CarouselItem>
            ),
          )}
          <CarouselItem as="div">
            <ImgCont
              to={FRONTEND_ENDPOINTS.dynamicSingleProduct(
                "632e6a413b206ec3f3e1ff2d",
              )}
            >
              <Img src="img/carousel/phantom.jpeg"></Img>
            </ImgCont>
            <ImgCont disappear as="div">
              <Img src="/img/logo.jpeg"></Img>
            </ImgCont>
          </CarouselItem>
        </SlideShow>

        <Control onClick={() => moverIzq(slideShow)}>
          {" "}
          <AiOutlineArrowLeft />
        </Control>
        <Control dcha onClick={() => moverDcha(slideShow)}>
          <AiOutlineArrowRight />
        </Control>
      </ContainerCarousel>
    </>
  );
};
